import { Component, ElementRef, HostListener, OnDestroy } from '@angular/core';
import { RouterLink } from '@angular/router';

interface ShowcaseProject {
  slug: string;
  title: string;
  category: string;
  logo: string;
}

@Component({
  selector: 'app-projects-showcase',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './projects-showcase.html',
  styleUrl: './projects-showcase.scss',
})
export class ProjectsShowcase implements OnDestroy {
  private readonly cdn = 'https://images.sitco.ru';

  activeShowcaseIndex = 0;
  displayedShowcaseIndex = 0;
  pillAnimate = true;

  private pillAnimationTimer?: number;

  readonly showcaseProjects: ShowcaseProject[] = [
    {
      slug: 'fcs',
      title: 'FCS Ltd',
      category: 'Travel Tech',
      logo: `${this.cdn}/main/F-logo.svg`,
    },
    {
      slug: 'meet-greet',
      title: 'Meet + Greet',
      category: 'Travel Tech',
      logo: `${this.cdn}/main/M-logo.svg`,
    },
    {
      slug: 'shatte',
      title: 'Shatte',
      category: 'E-commerce',
      logo: `${this.cdn}/main/S-logo.svg`,
    },
  ];

  constructor(private readonly elementRef: ElementRef<HTMLElement>) {}

  activeShowcaseProject(): ShowcaseProject {
    return this.showcaseProjects[this.displayedShowcaseIndex];
  }

  ngOnDestroy(): void {
    window.clearTimeout(this.pillAnimationTimer);
  }

  @HostListener('window:scroll')
  onWindowScroll(): void {
    const screens = Array.from(
      this.elementRef.nativeElement.querySelectorAll<HTMLElement>('.project-screen'),
    );

    if (!screens.length) {
      return;
    }

    const triggerLine = window.innerHeight * 0.55;
    let nextIndex = this.activeShowcaseIndex;

    screens.forEach((screen, index) => {
      const rect = screen.getBoundingClientRect();

      if (rect.top <= triggerLine && rect.bottom >= triggerLine) {
        nextIndex = index;
      }
    });

    this.changeShowcaseProject(nextIndex);
  }

  private changeShowcaseProject(index: number): void {
    if (index === this.activeShowcaseIndex) {
      return;
    }

    this.activeShowcaseIndex = index;
    this.pillAnimate = false;

    window.clearTimeout(this.pillAnimationTimer);

    this.pillAnimationTimer = window.setTimeout(() => {
      this.displayedShowcaseIndex = index;

      requestAnimationFrame(() => {
        this.pillAnimate = true;
      });
    }, 120);
  }
}
